import React from 'react';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';

import GET_COACHING_HOME_DASHBOARD_QUERY from 'coaching/queries/GetCoachingHomeDashboard.gql';
import {
  GetCoachingHomeDashboard,
  GetCoachingHomeDashboard_coaching_coachingHomeDashboard,
} from 'coaching/queries/__generated__/GetCoachingHomeDashboard';

export type Props = {
  children: (props: {
    coachingHomeDashboard?: GetCoachingHomeDashboard_coaching_coachingHomeDashboard;
    shouldShowBillingTab?: boolean;
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function GetCoachingHomeDashboardContainer(props: Props) {
  return (
    <Query<GetCoachingHomeDashboard> query={GET_COACHING_HOME_DASHBOARD_QUERY}>
      {({ loading, error, data }) => {
        return props.children({
          coachingHomeDashboard: data?.coaching_coachingHomeDashboard,
          shouldShowBillingTab: data?.coaching_shouldShowBillingTab,
          loading,
          error,
        });
      }}
    </Query>
  );
}
